import { IconButton } from "@chakra-ui/react";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { useState, ReactNode } from "react";
import SidebarDrawer from "./sidebar-drawer";
import { MobileNavProvider } from "./mobile-nav-context";

interface MobileNavigationMenuProps {
  children: ReactNode;
}

export default function MobileNavigationMenu({ children }: MobileNavigationMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const triggerButton = (
    <IconButton
      colorScheme="brand.primary"
      bg="transparent"
      color="special.mobileNavBackgroundContrastColor"
      border="1px solid"
      borderColor="special.mobileNavBackgroundContrastColor"
      _hover={{
        color: "brand.primary.mainContrast",
        bg: "brand.primary.main",
      }}
      _active={{
        color: "brand.primary.mainContrast",
        bg: "brand.primary.main",
      }}
      mx={5}
      size="md"
      icon={<HiOutlineMenuAlt2 fontSize="25px" />}
      aria-label="Open navigation menu"
      onClick={() => setIsOpen(true)}
    />
  );

  return (
    <SidebarDrawer
      isOpen={isOpen}
      onClose={handleClose}
      placement="left"
      triggerButton={triggerButton}
      showTrigger={true}
      width="200px"
    >
      <MobileNavProvider closeMobileNav={() => setIsOpen(false)}>{children}</MobileNavProvider>
    </SidebarDrawer>
  );
}
